import { Box } from "@mui/material"
import { PageCard, PageCardContent } from "components/card"
import React from "react"

export const EventDetailKioskHPage = ({ Layout = Box }) => {
  return (
    <Layout aside={<></>}>
      <PageCard>
        <PageCardContent>Event Detail Page</PageCardContent>
      </PageCard>
    </Layout>
  )
}
